import { IUser } from './Admin';

export interface IComment {
  id: number;
  uid: string;
  created_on: string;
  created_on_utc: string;
  text: string;
  created_by: IUser;
  userImage: string;
  comment_thread_id: string | number | null;
  comment_thread_uid?: string;
}

export interface ICommentForCreation {
  text: string;
  comment_thread_id?: string | null;

}

export interface ICommentForCreationWithoutCommentThreadId {
  text: string;
}

export interface ICommentThread {
  id: number;
  uid: string;
  status: string;
  block_id: number; // send to server, same as block_uid
  block_uid?: string; // received from server, same as block_id
  comments: IComment[]
  created_on: string;
  created_on_utc: string;
}

export interface ICommentThreadForCreation {
  blockId: string;
}

export interface ICommentThreadForUpdate {
  status: string;
}

export enum CommentThreadStatus {
  OPEN = 'OPEN',
  CLOSED = 'CLOSED',
}
